<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Workday Status
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-billing-filter (searchEvent)="onSearch($event)" [filterFields]="fields"
                        [billingScreen]="'workday'"></ppl-billing-filter>
                </div>
                <div class="table-style">
                    @if(workdayList.length > 0) {
                    <ppl-list-table [customDataLoaded]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [cols]="cols" [enableActions]="true" [data]="workdayList" (rowDetailEvent)="rowClicked($event)"
                        [disableSelection]="true" (gridAction)="onAction($event)" [gridTitle]="false"
                        [actionButtons]="actionButtons" [pagination]="true" [loadPage]="true"
                        (onPageLoad)="onPageLoad($event)" [from]="'billing'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="filter-panel">
    <ng-template #serviceDialog let-cancel="cancel">
        <label for="serviceCodeInput">Workday Sales:</label>
        <input id="serviceCodeInput" nz-input type="text" [(ngModel)]="selectedServiceCode" />
    </ng-template>
</div>